import Repository from './client/TbsJsonAxiosClient';

const resource = '';

type InputData = {
  wait: number;
  title: string;
  pcImage: string;
  spImage: string;
  external: boolean;
  url: string;
  date: string;
  description: string;
  channel: '' | '1,2' | '1' | '2';
};

export interface Ichioshi {
  title: string;
  thumbnail: string;
  page: string;
  time: string;
  description: string;
  channel: [] | [1] | [2] | [1, 2];
}

export const useIchioshiRepository = () => {
  /**
   * メインビジュアルカルーセルJSONを取得する
   */
  const get = async (): Promise<{ contents: Ichioshi[] }> => {
    const { data } = await Repository.get(`${resource}/ichioshi.json`).catch((e) => {
      throw e;
    });

    const result = data.contents.map((item: InputData) => {
      return {
        title: item.title,
        thumbnail: item.spImage,
        page: item.url,
        time: item.date,
        description: item.description,
        channel: item.channel === '1' ? [1] : item.channel === '2' ? [2] : item.channel === '1,2' ? [1, 2] : [],
      };
    });

    return { contents: result };
  };

  return {
    get,
  };
};

export type IchioshiRepository = ReturnType<typeof useIchioshiRepository>;
